import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(8),
    overflowWrap: 'anywhere',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: theme.breakpoints.width('md'),
    },
  },
  active: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
